import { useGetUserProfile } from '../../Hooks/useUser';
import { useEffect, useState } from 'react';
import './one-profile.scss';
import BizUserImage from '../Mini/BizUserImage';
import BizPhrase from '../../../../../FrontEnd/Components/Phrase';
import { User } from '../../Types/user';
import { getPathWithRootPath } from '../../Services/common';

type profileProps = {
	userId?: number;
	userObject?: User | undefined | null;
};

const OneProfile = ({ userId, userObject }: profileProps) => {
	const { getUserProfile, user: userData } = useGetUserProfile();
	// const user = userObject !== undefined ? userObject : userData;
	const [user, setUser] = useState<User | undefined | null>(userObject !== undefined ? userObject : userData);

	useEffect(() => {
		console.log('userObject log', userObject);
		if (userObject !== undefined) setUser(userObject);
		else if (userData !== undefined) setUser(userData);
	}, [userObject, userData]);

	useEffect(() => {
		if (userId && userId > 0) getUserProfile(userId);
	}, [userId]);

	useEffect(() => {
		console.log('user', user);
	}, [user]);

	if (user === null) {
		return <div>User not found...</div>;
	}

	if (user === undefined) {
		return <div>Loading...</div>;
	}

	console.log(user);

	const getCustomFieldName = (systemName: string, fallbackName: string = '') => {
		const cv = user.CustomFields?.find((field) => field.SystemName === systemName);

		return cv?.Name || fallbackName;
	};

	const getCustomFieldValue = (systemName: string, splitIndex?: number) => {
		const cv = user.CustomFields?.find((field) => field.SystemName === systemName);

		if (splitIndex !== undefined && cv?.Value?.Value) {
			const splits = cv.Value.Value.split('|');
			return splits[splitIndex] || splits[splits.length - 1] || '';
		}

		return cv?.Value?.Value || '';
	};

	return (
		<div className='biz-profile-wrapper'>
			<section className='profile-header'>
				<div className='profile-photo'>
					<BizUserImage
						imageUrl={user.Photo}
						size={100}
						showOnlineStatus={true}
						isOnline={true}
						initials={`${user.FirstName.charAt(0)}${user.LastName.charAt(0)}`.toUpperCase()}
					/>
				</div>
				<div className='profile-info'>
					<h2>{user.FullName}</h2>
				</div>
			</section>
			<section className='profile-body'>
				{getCustomFieldValue('COMPANY') && (
					<div className='profile-section'>
						<i className='fa-solid fa-building'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.COMPANY'></BizPhrase>
						</h3>
						<p>{getCustomFieldValue('COMPANY')}</p>
					</div>
				)}
				{getCustomFieldValue('TITLE') && (
					<div className='profile-section'>
						<i className='fa-solid fa-briefcase'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.ROLE'></BizPhrase>
						</h3>
						<p>{getCustomFieldValue('TITLE')}</p>
					</div>
				)}
				{getCustomFieldValue('INDUSTRY') && (
					<div className='profile-section'>
						<i className='fa-solid fa-industry'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.INDUSTRY'></BizPhrase>
						</h3>
						<p>{getCustomFieldValue('INDUSTRY')}</p>
					</div>
				)}
				{user.Units && user.Units.length > 0 && (
					<div className='profile-section'>
						<i className='fa-solid fa-building'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.COMPANY'></BizPhrase>
						</h3>
						<p>{(user.Units && user.Units[0].Name) || user.Company}</p>
					</div>
				)}
				{user.CountryName && (
					<div className='profile-section'>
						<i className='fa-solid fa-globe'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.COUNTRY'></BizPhrase>
						</h3>
						<p>{user.CountryName}</p>
					</div>
				)}
				{user.Email && (
					<div className='profile-section'>
						<i className='fa-solid fa-envelope'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.EMAIL'></BizPhrase>
						</h3>
						<p>{user.Email} </p>
					</div>
				)}
				{user.Mobile && (
					<div className='profile-section'>
						<i className='fa-solid fa-phone'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.PHONE'></BizPhrase>
						</h3>
						<p>{user.Mobile}</p>
					</div>
				)}
				{getCustomFieldValue('BIO') && (
					<div className='profile-section'>
						<i className='fa-solid fa-user'></i>
						<h3>
							<BizPhrase phraseKey='GLOBAL.ABOUT'></BizPhrase>
						</h3>
						<p>{getCustomFieldValue('BIO')}</p>
					</div>
				)}
				{getCustomFieldValue('INTROVID') && (
					<div className='profile-section'>
						<i className='fa-solid fa-video'></i>
						<h3>{getCustomFieldName('INTROVID', 'Introduction video')}</h3>
						<p>
							<video width='100%' controls>
								<source src={getPathWithRootPath(getCustomFieldValue('INTROVID', 2))} type='video/mp4' />
								Your browser does not support the video tag.
							</video>
						</p>
					</div>
				)}
			</section>
		</div>
	);
};

export default OneProfile;
